<template>
  <div class="auth">
    <div class="auth__form">
      <h1 class="auth__title"> Войти в личный кабинет </h1>
      <form @submit.prevent="onSubmit($event)">
        <div class="form-group" :class="{ 'error': form.username.error.status }">
          <div class="form-control">
            <label> {{ form.username.label }} </label>
            <input type="text"  autocomplete="off" v-model="form.username.value">
          </div>
          <div class="form-error"> {{ form.username.error.message }} </div>
        </div>
        <div class="form-group" :class="{ 'error': form.password.error.status }">
          <div class="form-error"> {{ form.password.error.message }} </div>
          <div class="form-control">
            <label> {{ form.password.label }} </label>
            <input type="password"  autocomplete="off" v-model="form.password.value">
          </div>
        </div>
        <transition name="slide-fade">
          <div class="error-text" v-if="errorMessage != ''"> {{ errorMessage }} </div>
        </transition>
        <button type="submit" class="btn btn--lg btn--default btn--inline" style="margin-top: 15px;">
          <div class="btn--text"> Войти </div>
          <div class="btn--loader"></div>
        </button>
      </form>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PageLogin',
    data: () => ({
      errorMessage: '',
      form: {
        username: {
          label: 'Логин',
          value: '',
          required: {
            status: true,
            message: 'Заполните поле',
          },
          validate: [
            {regexp: /.{5,}/, msg: 'Минимум 5 символов'}, 
          ],
          error: {
            status: false,
            message: null,
          }
        },
        password: {
          label: 'Пароль',
          value: '',
          required: {
            status: true,
            message: 'Заполните поле',
          },
          validate: [
            {regexp: /.{6,}/, msg: 'Минимум 6 символов'}, 
          ],
          error: {
            status: false,
            message: null,
          }
        },
      }
    }),
    watch: {
      'form.username.value': function () {
        this.form.username.error.status = false;
      },
      'form.password.value': function () {
        this.form.password.error.status = false;
      },
    },

    methods: {
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      async onSubmit (e) {
        let btn = e.submitter;
        btn.classList.add('btn--load');
        this.errorMessage = '';
        // Валидация формы, готовность к отправке
        let isReady = this.helpers.validateFields(this.form);
        if(isReady) {
          const username = this.form.username.value;
          const password = this.form.password.value;
          const isAuth = await this.$store.dispatch('login', { username, password });
          if (isAuth) {
            this.$router.push({ name: 'PageWork' });
          } else {
            this.errorMessage = 'Неверный логин или пароль';
          }
        }
        btn.classList.remove('btn--load');
      },
    },
  }
</script>

<style scoped>

  .auth {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100dvh;
    width: 100%;
  }

  .auth__title {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 30px;
    line-height: 1.2;
    text-align: center;
  }

  .auth__form {
    max-width: 100%;
    padding: 20px;
    width: 540px;
  }

  @media (max-width: 767px) {
    
  }

</style>